import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {UIChart} from 'primeng/chart';
import {AnswerCompleteness} from '../../rfi-individual-results.calc';
import {RfiAnswerCompletenessComponent} from '../../parts/rfi-answer-completeness/rfi-answer-completeness.component';
import {RfiMetricGridComponent} from '../../parts/rfi-metric-grid/rfi-metric-grid.component';
import {MetricCard} from '../../rfi-individual-results-modal.types';

@Component({
  selector: 'app-rfi-finance-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, UIChart, RfiAnswerCompletenessComponent, RfiMetricGridComponent],
  host: {class: 'flex flex-col gap-4'},
  templateUrl: './rfi-finance-section.component.html',
})
export class RfiFinanceSectionComponent {
  readonly completeness = input.required<AnswerCompleteness>();
  readonly cards = input.required<MetricCard[]>();
  readonly chartData = input<object | null>(null);

  protected readonly chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {legend: {position: 'bottom'}},
    scales: {y: {beginAtZero: true, title: {display: true, text: 'Mio. €'}}},
  };
}
